<template>
    <div id="referral">
        <h2>Referral Information</h2>
        <div class="ref-question-group">
            <span class="ref-question">Are Referrals Required: </span><span class="ref-detail">{{referral.required ? 'Yes' : 'No'}}</span>
            <div class="ref-detail" v-show="referral.required">
                <span class="ref-question">Entity That Requires Referral: </span><span class="ref-detail">{{referral.referEntity}}</span>
            </div>
            <div class="ref-detail" v-show="referral.required">
                <span class="ref-question">Referral Processing Time: </span><span class="ref-detail">{{referral.referTurnaround}}</span>
            </div>
            <div class="ref-detail" v-show="referral.required">
                <span class="ref-question">Referral Form Location: </span><span class="ref-detail">{{referral.formLocation == 0 ? 'In Person' : (referral.formLocation == 1 ? 'Online' : 'In Person & Online')}}</span>
            </div>
            <div class="ref-detail" v-show="referral.formLocation && referral.formLocation > 0">
                <span class="ref-question">Referral Form: </span><span class="ref-detail"><a v-bind:href="referral.formURL">Link</a></span>
            </div>
        </div>
        <div class="ref-question-group">
            <span class="ref-question">Can Clients Self-Refer to Services: </span><span class="ref-detail">{{referral.selfRefer ? 'Yes' : 'No'}}</span>
        </div>
        <div class="ref-question-group">
            <span class="ref-question">Is Prior Authorization Required: </span><span class="ref-detail">{{referral.authRequired ? 'Yes' : 'No'}}</span>
            <div class="ref-detail" v-show="referral.authRequired">
                <span class="ref-question">Entity That Requires Prior Authorization: </span><span class="ref-detail">{{referral.priorAuthEntity}}</span>
            </div>
        </div>
        <div v-show="referral.intakeForm">
            <a v-bind:href="referral.intakeForm" class="btn btn-primary btn-sm">Intake Form</a>
        </div>
        <div class="ref-question-group" v-show="referral.notes">
            <span class="ref-question">Referral Notes: </span><span class="ref-detail">{{referral.notes}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Referral",
        props: ['referral']
    }
</script>

<style scoped>

</style>